export default __webpack_public_path__ + "static/media/push37.0e211cb5.gif";